import { useEffect, useState, useContext, useMemo } from "react";
import { fetchAllPromisedData, httpGet } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../common/constant";
import { UserDetails } from "../../../../../../appContext";

export const fetchExamCharges = async (
    psid, 
    setStudentCharges, 
    allActiveBusinessArea = [], 
    setState
) => {
    try {
        setStudentCharges(prev => ({
            ...prev,
            loading: true
        }))
        const response = await httpGet(`${endpoint.examCharges.getExamDetails}/${psid}`, true, true);
        
        if (response?.code === 412) {
            window.location.reload();
            return;
        }
        
        const resp = response?.data;

        if (resp?.code === 200) {
            const examCharges = resp?.data;
            const updatedExamCharges = examCharges?.map(charge => ({
                ...charge,
                businessArea: charge?.businessAreaValue,
                buId: allActiveBusinessArea?.find(bu => bu?.label === charge.businessAreaValue)?.value
            }))

            setStudentCharges(prev => ({
                ...prev,
                OTHER_CHARGES: updatedExamCharges
            }))

            setState(response?.state);
        }

    } catch (err) {
        console.error(err);
    } finally {
        setStudentCharges(prev => ({
            ...prev,
            loading: false
        }))
    }
}

export const useGetUserRoledId = () => {
    const [roleId, setRoleId] = useState([]);
    const data = useContext(UserDetails);

    useEffect(() => {
        const fetchDetails = async () => {
            const details = await fetchAllPromisedData(
                `${endpoint.getUserByEmployeeId}/${data?.employeeId}`,
                true
            );
            if (details && details?.code == 200) {
                const roleId = await details?.data?.userIdProjectRoleDtoList
                    .map((item) => {
                        return item?.roleInformationDtoList.map((i) => {
                            return i?.roleId;
                        });
                    })
                    .flat();
                setRoleId(roleId);
            }
        };
        data && fetchDetails();
    }, [data]);

    return roleId;
}


export const useGetSelectedChargesTotals = selectedCharges => {
    return useMemo(() => {
        let totalBaseAmount = 0,
            totalConcessionAmount = 0,
            totalPayableAmount = 0,
            totalTaxes = 0,
            totalFinalPayable = 0



        selectedCharges['OTHER_CHARGES'].forEach(charge => {
            const { basePrice, waveOffAmount, netPayableAmount, taxes, finalPayable } = charge;
            totalBaseAmount += basePrice;
            totalConcessionAmount += waveOffAmount;
            totalPayableAmount += netPayableAmount;
            totalTaxes += taxes;
            totalFinalPayable += finalPayable;
        });

        return {
            totalBaseAmount,
            totalConcessionAmount,
            totalPayableAmount,
            totalTaxes,
            totalFinalPayable
        }

    }, [selectedCharges])

}